let id = 0;

export default class UUID {
    #id;

    constructor() {
        id++;
        this.#id = `uuid-${id}`;
    }

    ID() {
        return this.#id;
    }
}